var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchfield(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_920_215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#EEF1F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_920_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2846 17.1472L11.0506 11.9132C10.634 12.2572 10.1548 12.5265 9.61315 12.7209C9.07148 12.9153 8.51112 13.0126 7.93206 13.0126C6.50776 13.0126 5.30233 12.5194 4.31577 11.5331C3.32922 10.5468 2.83594 9.34168 2.83594 7.91775C2.83594 6.49381 3.32909 5.28824 4.3154 4.30106C5.3017 3.3139 6.50683 2.82031 7.93077 2.82031C9.3547 2.82031 10.5603 3.31359 11.5474 4.30015C12.5346 5.2867 13.0282 6.49213 13.0282 7.91644C13.0282 8.51152 12.9283 9.0799 12.7285 9.62156C12.5287 10.1632 12.2622 10.6344 11.9288 11.035L17.1628 16.269L16.2846 17.1472ZM7.93206 11.7626C9.00579 11.7626 9.91524 11.39 10.6604 10.6448C11.4056 9.89962 11.7782 8.99016 11.7782 7.91644C11.7782 6.84272 11.4056 5.93326 10.6604 5.18806C9.91524 4.44287 9.00579 4.07027 7.93206 4.07027C6.85834 4.07027 5.94888 4.44287 5.20369 5.18806C4.45851 5.93326 4.08592 6.84272 4.08592 7.91644C4.08592 8.99016 4.45851 9.89962 5.20369 10.6448C5.94888 11.39 6.85834 11.7626 7.93206 11.7626Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchfield);
export default __webpack_public_path__ + "static/media/Searchfield.6137bbd44cb22456de04d9627ed137ac.svg";
export { ForwardRef as ReactComponent };